export default {
  CLIENT_ID: "d00bdb1af84c4faef82c",
  CLIENT_SECRET: "16bf26fbf9fc5aad2f1eee3b94c5d6363d13470d",
  REDIRECT_URL: "http://localhost:8788/",
  AUTHORIZATION_ENDPOINT: "https://github.com/login/oauth/authorize",
  TOKEN_ENDPOINT: "https://github.com/login/oauth/access_token",
  RESOURCE_ENDPOINT: "https://api.github.com/",
};
